import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}
// "Stored Token:", localStorage.getItem("token"));
// "Stored Refresh Token:", localStorage.getItem("refreshToken"));

export const getLeadNotes = async (lead) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/lead/leads/${lead.id}/notes/`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};
//127.0.0.1:8000/lead/api/summary/

export const getLeadSummary = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/lead/api/summary/`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const deleteLeadNote = async (leadId, noteId) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/lead/leads/${leadId}/add-note/${noteId}/`, // Endpoint to delete a specific lead note
      getHeaders()
    );

    return response.data; // Return the response with the deletion message
  } catch (err) {
    console.error("Error deleting lead note:", err);
    throw err; // Rethrow the error for further handling if necessary
  }
};
export const updateLeadNote = async (leadId, noteId, updatedData) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/lead/leads/${leadId}/add-note/${noteId}/`, // Endpoint to update a specific lead note
      updatedData,
      getHeaders()
    );

    return response.data; // Return the updated note data
  } catch (err) {
    console.error("Error updating lead note:", err);
    throw err; // Rethrow the error for further handling if necessary
  }
};

export const addLeadNotes = async (currentLead, noteData) => {
  // getHeaders());
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/lead/leads/${currentLead.id}/add-note/`,
      noteData,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const getLeads = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/lead/api`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const getLead = async (id) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/lead/api/${id}/`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const updateLeadForm = async (id, data) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/lead/api/${id}/`,
      data,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const sendSwotTest = async (id) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/lead/send-swot/${id}/`,
      {},
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};
